export default __webpack_public_path__ + "static/media/paul_thumb.f6920efc.jpg";